import { render, staticRenderFns } from "./UserFamilyListSection.vue?vue&type=template&id=0db20cf8"
import script from "./UserFamilyListSection.vue?vue&type=script&lang=js"
export * from "./UserFamilyListSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports